import { Archive, MoreHorizontal, Pencil, Scale } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { Account } from "@/lib/finance";

export interface AccountActionHandlers {
  onEdit: (a: Account) => void;
  onAdjust: (a: Account) => void;
  onArchive: (a: Account, archived: boolean) => void;
}

export function AccountActions({ account, onEdit, onAdjust, onArchive }: { account: Account } & AccountActionHandlers) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="rounded-md p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-[#1B2A4A]" aria-label="Acciones" data-testid={`account-actions-${account.id}`}>
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-white">
        <DropdownMenuItem onSelect={() => onEdit(account)} className="cursor-pointer" data-testid={`account-edit-${account.id}`}>
          <Pencil className="mr-2 h-4 w-4" /> Editar
        </DropdownMenuItem>
        {!account.is_archived && (
          <DropdownMenuItem onSelect={() => onAdjust(account)} className="cursor-pointer" data-testid={`account-adjust-${account.id}`}>
            <Scale className="mr-2 h-4 w-4" /> {account.account_type === "investment" ? "Actualizar valor" : "Registrar ajuste"}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={() => onArchive(account, !account.is_archived)} className="cursor-pointer" data-testid={`account-archive-${account.id}`}>
          <Archive className="mr-2 h-4 w-4" /> {account.is_archived ? "Reactivar" : "Archivar"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
